import {register} from '@shopify/theme-sections';

const selectors = {
  videoWithControls: '[data-video-with-controls]',
  playBtn: '[data-video-play]',
  volumeBtn: '[data-video-volume]',
};

const classes = {
  playActive: 'video__play-control--play',
  pauseActive: 'video__play-control--pause',
  muteActive: 'video__volume-control--mute',
  unmuteActive: 'video__volume-control--unmute',
};

const sectionType = 'video-banner';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      const videosWithControls = container.querySelectorAll(selectors.videoWithControls);

      videosWithControls?.forEach((videoWrapper) => {
        const video = videoWrapper.querySelector('video');
        if (!video) return;

        const playControl = videoWrapper.querySelector(selectors.playBtn);
        const volumeControl = videoWrapper.querySelector(selectors.volumeBtn);

        const showPlayIcon = () => {
          playControl?.classList.add(classes.playActive);
          playControl?.classList.remove(classes.pauseActive);
        };

        const showPauseIcon = () => {
          playControl?.classList.remove(classes.playActive);
          playControl?.classList.add(classes.pauseActive);
        };

        const showMuteIcon = () => {
          volumeControl.classList.add(classes.muteActive);
          volumeControl.classList.remove(classes.unmuteActive);
        };

        const showUnmuteIcon = () => {
          volumeControl.classList.remove(classes.muteActive);
          volumeControl.classList.add(classes.unmuteActive);
        };

        // Handle play / pause control click
        playControl?.addEventListener('click', () => {
          if (video.paused || video.ended) {
            video.play();
            return;
          }
          video.pause();
        });

        // Handle mute / unmute control click
        volumeControl?.addEventListener('click', () => {
          video.muted = !video.muted;
        });

        // Update state for play / pause button when video plays
        video?.addEventListener('play', showPauseIcon);

        // Update state for play / pause button when video pauses
        video?.addEventListener('pause', showPlayIcon);

        // Update state for play / pause button when video ends
        video?.addEventListener('ended', showPlayIcon);

        // Update state for mute / unmute button when volume changes
        video?.addEventListener('volumechange', () => {
          if (video.muted) {
            showMuteIcon();
            return;
          }

          showUnmuteIcon();
        });
      });
    },
  });
